import { render } from "./Edit-rush.vue?vue&type=template&id=2f5a11d8&scoped=true"
import script from "./Edit-rush.vue?vue&type=script&lang=js"
export * from "./Edit-rush.vue?vue&type=script&lang=js"

import "./Edit-rush.vue?vue&type=style&index=0&id=2f5a11d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5a11d8"]])

export default __exports__